import { Injectable, isDevMode } from '@angular/core';

const KEY = 'qp';

@Injectable({ providedIn: 'root' })
export class QueryParamsService {
  storage = window.localStorage;

  hasQueryParamStorage() {
    return !!this.getQueryParamStorage();
  }

  setQueryParamStorage(value: string) {
    this.storage.setItem(KEY, value);
  }

  getQueryParamStorage() {
    return this.storage.getItem(KEY);
  }

  removeQueryParamStorage() {
    this.storage.removeItem(KEY);
  }

  setQueryParamItem(path: string, params: URLSearchParams) {
    const allQueryParams = this.getQueryParamStorage()
      ? JSON.parse(this.getQueryParamStorage() as any)
      : {};

    const obj = {} as any;

    for (const e of params) {
      const [key, value] = e;

      if (key === 'pagination') {
        continue;
      }

      if(typeof value === 'object'){
        continue;
      }

      obj[key] = value;
    }

    allQueryParams[path] = obj;
    this.setQueryParamStorage(JSON.stringify(allQueryParams));
  }

  getQueryParamItem(path: string) {
    const allQueryParams = this.getQueryParamStorage()
      ? JSON.parse(this.getQueryParamStorage() as any)
      : {};

    if (allQueryParams[path]) {
      return allQueryParams[path];
    }

    return null;
  }
}
